export const companyDetailsConstants = {
  //login
  COMPANY_DETAILS_BY_ID_ACTION_REQUEST: "COMPANY_DETAILS_BY_ID_ACTION_REQUEST",
  COMPANY_DETAILS_BY_ID_ACTION_SUCCESS: "COMPANY_DETAILS_BY_ID_ACTION_SUCCESS",
  COMPANY_DETAILS_BY_ID_ACTION_FAILURE: "COMPANY_DETAILS_BY_ID_ACTION_FAILURE",

  COMPANY_LIST_ACTION_REQUEST: "COMPANY_LIST_ACTION_REQUEST",
  COMPANY_LIST_ACTION_SUCCESS: "COMPANY_LIST_ACTION_SUCCESS",
  COMPANY_LIST_ACTION_FAILURE: "COMPANY_LIST_ACTION_FAILURE",

  COMPANY_JOBS_LIST_ACTION_REQUEST: "COMPANY_JOBS_LIST_ACTION_REQUEST",
  COMPANY_JOBS_LIST_ACTION_SUCCESS: "COMPANY_JOBS_LIST_ACTION_SUCCESS",
  COMPANY_JOBS_LIST_ACTION_FAILURE: "COMPANY_JOBS_LIST_ACTION_FAILURE",
};
